// extracted by mini-css-extract-plugin
module.exports = {"title":"Hit_title__SIbl2","snippet":"Hit_snippet__n3lJt","section":"Hit_section__FjNpV","separator":"Hit_separator__w_ozA"};